import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import BrandJustLogo from "@hl/base-components/lib/assets/icons.generated/BrandJustLogo";
import LooksrareLogo from "@hl/base-components/lib/assets/icons.generated/LooksrareLogo";
import OpenseaLogo from "@hl/base-components/lib/assets/icons.generated/OpenseaLogo";
import X2Y2Logo from "@hl/base-components/lib/assets/icons.generated/X2Y2Logo";
import { getReservoirChain, isTestnet } from "../../../utils/blockchain";
import { FEATURE_FLAGS, useFeatureFlags } from "../../auth/hooks";
const reservoirMarketplace = {
    name: "Highlight",
    imageUrl: "https://api.reservoir.tools/redirect/sources/reservoir/logo/v2",
    logo: _jsx(BrandJustLogo, {}),
    domain: "highlight.xyz",
    orderbook: "reservoir",
    orderKind: "seaport-v1.6",
};
const foreignMarketplaces = [
    {
        name: "LooksRare",
        domain: "looksrare.org",
        imageUrl: "https://api.reservoir.tools/redirect/sources/looksrare/logo/v2",
        logo: _jsx(LooksrareLogo, {}),
        orderbook: "looks-rare",
        orderKind: "looks-rare-v2",
    },
    {
        name: "X2Y2",
        domain: "x2y2.io",
        imageUrl: "https://api.reservoir.tools/redirect/sources/x2y2/logo/v2",
        logo: _jsx(X2Y2Logo, {}),
        orderbook: "x2y2",
        orderKind: "x2y2",
    },
    {
        name: "OpenSea",
        domain: "opensea.io",
        imageUrl: "https://api.reservoir.tools/redirect/sources/opensea/logo/v2",
        logo: _jsx(OpenseaLogo, {}),
        orderbook: "opensea",
        orderKind: "seaport-v1.6",
    },
    {
        name: "Blur",
        domain: "blur.io",
        imageUrl: "https://api.reservoir.tools/redirect/sources/blur.io/logo/v2",
        logo: null,
        orderbook: "blur",
        orderKind: "blur",
    },
    {
        name: "Magic Eden",
        domain: "magiceden.io",
        imageUrl: "https://api.reservoir.tools/redirect/sources/magiceden.io/logo/v2",
        logo: null,
        orderbook: "magiceden",
        orderKind: "magiceden",
    },
];
const allMarketplaces = [reservoirMarketplace, ...foreignMarketplaces];
const useMarketplaces = () => {
    // TODO: implement a call to reservoir to retrieve it
    return { allMarketplaces, reservoirMarketplace, foreignMarketplaces };
};
export const useDisabledMarketplaceFF = () => {
    const enable = useFeatureFlags(FEATURE_FLAGS.MARKETPLACE_ALL_FEATURES, true);
    return !enable;
};
export const useExternalMarketplaceUrl = (collection, tokenId) => {
    if (collection == null)
        return null;
    const chainId = collection.chainId;
    const chain = getReservoirChain(chainId);
    if (chain == null)
        return null;
    const path = tokenId
        ? `${chain}/asset/${collection.address}:${tokenId}?tab=info`
        : `${chain}/collection/${collection.address}`;
    return isTestnet(chainId)
        ? `https://testnets.reservoir.tools/${path}`
        : `https://marketplace.reservoir.tools/${path}`;
};
export default useMarketplaces;
